import { createApp } from 'vue';
import GarminGpxConverter from './GarminGpxConverter.vue';

const el = document.getElementById('vue-garmin-gpx');
if (el) {
  createApp(GarminGpxConverter).mount(el);
}
